import React from "react";
import { useGetAdsOne } from "../functions/homeAds.ts"; // Ajusta la ruta según corresponda

const AdListComponent = ({ page = 1, limit = 10 }) => {
    const { ads, isLoading, isError, error } = useGetAdsOne(page, limit);

    if (isLoading) return <p>Cargando anuncios...</p>;
    if (isError) return <p>Error: {error?.message || "No se pudieron cargar los anuncios"}</p>;

    // Asegurar que `ads` es un array antes de mapearlo
    const adsArray = Array.isArray(ads) ? ads : [ads];

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 p-4">
            {adsArray.map((ad) => (
                <div key={ad._id} className="border rounded-lg shadow-md p-4">
                    <img src={ad.image} alt={ad.title} className="w-full h-40 object-cover rounded-md" />
                    <h3 className="text-lg font-bold mt-2">{ad.title}</h3>
                    <p className="text-sm text-gray-600">{ad.description}</p>
                    <a
                        href={ad.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline block mt-2"
                    >
                        Ver más
                    </a>
                </div>
            ))}
        </div>
    );
};

export default AdListComponent;
